import {
    AbstractControl,
    FormGroup,
} from '@angular/forms';

export interface IFormAbstractControl<T = any> extends AbstractControl {
    value: Readonly<T>;
    setValue(value: T, options?: Object): void;
}

export type IFormFields<T> = { [K in keyof Required<T>]: K };

export abstract class FormComponent<T> {

    /**
     * Form field keys that can be used for type safety in .html
     * [formControlName]="fields.name" // same as formControlName="name"
     */
    public readonly abstract fields: IFormFields<T>;

    public abstract form?: FormGroup;

    /**
     * Helper function for `this.form.get()`
     * with autocomplete and Non-Null Assertion Operator
     */
    public getField = <K extends keyof T>(field: K) => {
        if (!this.form) {
            throw new Error(`Form is undefined, cannot get field ${field}`);
        }

        return this.form.get(field as string) as IFormAbstractControl<T[K]>;
    }

    /**
     * Helper function for multiple `this.form.get()`
     * with autocomplete and Non-Null Assertion Operator
     */
    public getFields = (...fields: (keyof T)[]) =>
        fields.map(f => this.getField(f))

    public disableFields = (...fields: (keyof T)[]) =>
        this.getFields(...fields).forEach(f => f.disable())

    public enableFields = (...fields: (keyof T)[]) =>
        this.getFields(...fields).forEach(f => f.enable())
}
